(function () {
  'use strict';

  // Force-hide third-party overlays: Cowi + Debutify page transition (runs on ALL pages inc. /cart)
  (function suppressOverlays() {
    function forceHide(el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
    }
    function shouldHide(el) {
      if (el.nodeType !== 1) return false;
      var id  = (el.getAttribute ? el.getAttribute('id') : '') || '';
      var cls = (typeof el.className === 'string' ? el.className : '') || '';
      var tag = el.tagName ? el.tagName.toLowerCase() : '';
      return id.indexOf('cowi') !== -1 ||
             tag.indexOf('cowi') !== -1 ||
             cls.indexOf('dbtfy-page-transition') !== -1;
    }
    function scanAndHide(root) {
      if (shouldHide(root)) { forceHide(root); return; }
      if (root.querySelectorAll) {
        root.querySelectorAll('[id*="cowi"], .dbtfy-page-transition').forEach(forceHide);
      }
    }
    document.querySelectorAll('[id*="cowi"], .dbtfy-page-transition').forEach(forceHide);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'childList') {
          m.addedNodes.forEach(scanAndHide);
        } else if (m.type === 'attributes' && shouldHide(m.target)) {
          forceHide(m.target);
        }
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  })();

  // ─── DISCOUNT LINK ROUTING ──────────────────────────────────────────────────
  // Codes arriving via URL (?discount=CODE on Klaviyo/SMS/ad links, or the
  // discount_code cookie set by /discount/CODE redirects) normally sit invisible
  // until checkout — bypassing the drawer's gift maths, progress bar and
  // gap-closer entirely. Route them through the cart instead: applying the code
  // via /cart/update.js makes final_line_price reflect it, so the gift engine
  // re-evaluates on the spend the customer will actually pay, and the drawer
  // shows the code badge the moment it opens.
  function cdReadCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  // The code waiting to be routed this page load, or '' when there is none.
  // A code already routed this session never re-routes — re-applying a code
  // the customer deliberately removed would fight them.
  function cdPendingUrlDiscount() {
    var code = '';
    try { code = new URLSearchParams(window.location.search).get('discount') || ''; } catch (e) {}
    if (!code) code = cdReadCookie('discount_code');
    code = String(code).trim();
    if (!code) return '';
    try {
      if (sessionStorage.getItem('cdRoutedDiscount') === code.toUpperCase()) return '';
    } catch (e) {}
    return code;
  }

  // Drop the ?discount param so a plain reload doesn't count as a fresh click.
  // The discount_code cookie (Shopify's own) is left alone — it keeps checkout
  // covered even if cart routing couldn't land the code.
  function cdStripDiscountParam() {
    if (!(window.history && history.replaceState)) return;
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has('discount')) {
        u.searchParams.delete('discount');
        history.replaceState(null, '', u.toString());
      }
    } catch (e) {}
  }

  // Apply a pending URL/cookie code to the cart. Resolves with the fresh cart
  // when a code was routed, null otherwise. Invalid codes fail silently — this
  // runs on page load, not from user input, so there is nobody mid-action to
  // show an error to.
  function routeUrlDiscount() {
    if (window.b2bCompanyName) return Promise.resolve(null);
    var code = cdPendingUrlDiscount();
    if (!code) return Promise.resolve(null);
    cdStripDiscountParam();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function () {
        // update.js responds before discount totals settle — refetch truth
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // Mark routed once the code has landed (or was rejected against a real
        // cart). Shopify won't hold a code on an EMPTY cart — stash it instead,
        // and cdApplyDeferredDiscount re-applies it the moment the first item
        // arrives (customers from ad/email links usually land cart-empty).
        var landed = (cart.cart_level_discount_applications || []).length > 0;
        if (landed || cart.item_count > 0) {
          try { sessionStorage.setItem('cdRoutedDiscount', code.toUpperCase()); } catch (e) {}
        } else {
          try { sessionStorage.setItem('cdDeferredDiscount', code); } catch (e) {}
        }
        return cart;
      })
      .catch(function () { return null; });
  }

  // Apply a deferred code (one that arrived while the cart was still empty)
  // now that the cart can hold it. Called on every fresh (non-optimistic)
  // render and on /cart load. Resolves with the discounted cart, or the
  // original cart when there's nothing to do. The deferred key is cleared
  // BEFORE the write — one attempt only, never a retry loop.
  function cdApplyDeferredDiscount(cart) {
    var code = '';
    try { code = sessionStorage.getItem('cdDeferredDiscount') || ''; } catch (e) {}
    if (!code || !cart || cart.item_count === 0) return Promise.resolve(cart);
    try { sessionStorage.removeItem('cdDeferredDiscount'); } catch (e) {}
    if ((cart.cart_level_discount_applications || []).length > 0) return Promise.resolve(cart);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (fresh) {
        try { sessionStorage.setItem('cdRoutedDiscount', code.toUpperCase()); } catch (e) {}
        return fresh;
      })
      .catch(function () { return cart; });
  }

  // On /cart: SSR already renders the correct cart content.
  // Debutify hides #main while waiting for buildCartPage() AJAX — that fetch never fires,
  // so we must force-reveal #main. MutationObserver re-reveals if Debutify re-hides.
  if (window.location.pathname === '/cart') {
    injectStyles();

    function revealCartMain() {
      var main = document.getElementById('main');
      if (main && main.style.display === 'none') main.style.removeProperty('display');
    }

    // Remove orphaned engraving SKUs — items with '_Customised Product' property whose
    // linked main item (matched via '_cust_id') is no longer in the cart.
    function cleanupOrphanEngravings() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items;
          // Collect _cust_id values present on visible (non-engraving) items
          var mainCustIds = {};
          items.forEach(function (item) {
            var props = item.properties || {};
            var isEng = Object.prototype.hasOwnProperty.call(props, '_Customised Product');
            if (!isEng && props['_cust_id']) {
              mainCustIds[props['_cust_id']] = true;
            }
          });
          // Find engraving items whose main item is gone
          var updates = {};
          var hasOrphans = false;
          items.forEach(function (item) {
            var props = item.properties || {};
            var isEng = Object.prototype.hasOwnProperty.call(props, '_Customised Product');
            if (isEng) {
              var cid = props['_cust_id'] || '';
              // Only remove if it has a _cust_id that doesn't match any main item.
              // Items without _cust_id use the old DTC model — leave them alone.
              if (cid && !mainCustIds[cid]) {
                updates[item.key] = 0;
                hasOrphans = true;
              }
            }
          });
          if (!hasOrphans) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () { window.location.reload(); });
        });
    }

    // Remove AOV gift lines that no longer qualify (self-contained mirror of the
    // drawer's syncGiftTiers — the drawer module below never runs on /cart).
    // Prevents a customer reaching checkout with a gift the discount won't zero.
    function cleanupGiftLines() {
      // Valid tiers = enabled, sane threshold. Runs even with zero tiers —
      // stale gift lines must never reach checkout at full price.
      var validTargets = {};
      (window.cdGiftTiers || []).forEach(function (t) {
        if (t && t.target > 0 && t.handle) validTargets[String(t.target)] = true;
      });
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var excl = String(window.cdGiftExcludeHandles || '').split(',')
            .map(function (s) { return s.trim(); }).filter(Boolean);
          var qual = cart.items.reduce(function (sum, i) {
            var p = i.properties || {};
            if (p['_aov_gift']) return sum;
            if (excl.indexOf(i.handle) !== -1) return sum;
            return sum + cdEffectiveLinePrice(i);
          }, 0);
          var updates = {}, dirty = false, seen = {};
          cart.items.forEach(function (i) {
            var t = (i.properties || {})['_aov_gift'];
            if (!t) return;
            // Orphaned (tier gone/edited), duplicate, or below threshold → remove
            if (!validTargets[t] || seen[t] || qual < parseInt(t, 10)) {
              updates[i.key] = 0; dirty = true; return;
            }
            seen[t] = true;
            // Gift is always qty 1 — SSR cart page has open qty controls
            if (i.quantity > 1) { updates[i.key] = 1; dirty = true; }
          });
          if (!dirty) return;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () { window.location.reload(); });
        });
    }

    // Capture-phase click handler fires before jQuery/Debutify handlers.
    // When user removes a customised item, atomically remove its linked engraving SKU too.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest
        ? e.target.closest('.js-cart-product-remove.cstm_removetrue')
        : null;
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var row = btn.closest('[data-line]');
      var lineIndex = row ? parseInt(row.getAttribute('data-line'), 10) : 0;
      if (!lineIndex) {
        var m = (btn.getAttribute('href') || '').match(/line=(\d+)/);
        if (m) lineIndex = parseInt(m[1], 10);
      }
      if (!lineIndex) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var target = cart.items[lineIndex - 1];
          if (!target) return;
          var props = target.properties || {};
          var custId = props['_cust_id'] || '';
          var updates = {};
          updates[target.key] = 0;
          if (custId) {
            cart.items.forEach(function (item) {
              var ip = item.properties || {};
              if (ip['_Customised Product'] !== undefined && ip['_cust_id'] === custId) {
                updates[item.key] = 0;
              }
            });
          }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () { window.location.reload(); });
        });
    }, true); // true = capture phase — fires before any jQuery bubbling handlers

    document.addEventListener('DOMContentLoaded', function () {
      revealCartMain();
      var obs = new MutationObserver(revealCartMain);
      var main = document.getElementById('main');
      if (main) obs.observe(main, { attributes: true, attributeFilter: ['style'] });
      setTimeout(function () { obs.disconnect(); }, 3000);
      // Serial, never parallel — Shopify carts do not tolerate racing writes.
      // Route any URL/cookie discount first (plus any code deferred from an
      // empty-cart landing) so cleanupGiftLines validates gifts against the
      // discounted totals the customer will actually pay.
      routeUrlDiscount()
        .then(function (c) {
          if (c) return cdApplyDeferredDiscount(c);
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(cdApplyDeferredDiscount);
        })
        .then(function () { return cleanupOrphanEngravings(); })
        .then(cleanupGiftLines)
        .catch(function () { cleanupGiftLines(); });
    });

    return;
  }

  var DRAWER_ID = 'cd-cart-drawer';

  function injectStyles() {
    if (document.getElementById('cd-cart-styles')) return;
    var s = document.createElement('style');
    s.id = 'cd-cart-styles';
    s.textContent = [
      /* Force html overflow-y to auto. Debutify injects CSS rules that set html{overflow:hidden}
         for mobile scroll-locking. !important overrides any such rule regardless of source. */
      'html{overflow-y:auto!important}',
      /* Drawer shell */
      '#cd-cart-drawer{display:none;position:fixed;inset:0;z-index:99999}',
      '#cd-cart-drawer.open{display:block}',
      '#cd-cart-overlay{position:absolute;inset:0;background:rgba(0,0,0,.45);z-index:1}',
      /* Panel */
      '#cd-cart-panel{position:absolute;top:0;right:0;width:504px;max-width:100vw;height:100%;background:#fff;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .3s cubic-bezier(0.4,0,.2,1);z-index:2;box-shadow:-4px 0 24px rgba(0,0,0,.12);}',
      '#cd-cart-drawer.open #cd-cart-panel{transform:translateX(0)}',
      /* Header */
      '#cd-cart-header{display:flex;justify-content:space-between;align-items:center;padding:14px 20px;flex-shrink:0}',
      '#cd-cart-title{font-size:20px;font-weight:700;letter-spacing:.02em;color:var(--c-ui);display:inline-flex;align-items:center}',
      '#cd-cart-count-badge{display:inline-flex;align-items:center;justify-content:center;min-width:26px;height:26px;background:var(--c-ui);color:#fff;border-radius:13px;font-size:14px;font-weight:700;padding:0 8px;margin-left:10px;letter-spacing:0}',
      '#cd-cart-close{background:none;border:none;cursor:pointer;color:var(--c-meta);font-size:22px;padding:4px;line-height:1;border-radius:6px;transition:color .15s,background .15s}',
      '#cd-cart-close:hover{color:var(--c-ui);background:var(--c-surface)}',
      /* Items scroll area */
      '#cd-items-wrap{flex:1;position:relative;overflow:hidden}',
      '#cd-cart-items{height:100%;overflow-y:auto;padding:16px 20px;box-sizing:border-box}',
      '#cd-cart-items::-webkit-scrollbar{width:4px}',
      '#cd-cart-items::-webkit-scrollbar-track{background:var(--c-stage)}',
      '#cd-cart-items::-webkit-scrollbar-thumb{background:#ddd;border-radius:2px}',
      /* Items loading overlay */
      '#cd-items-loading{display:none;position:absolute;inset:0;background:rgba(255,255,255,.65);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);align-items:center;justify-content:center;z-index:5}',
      '#cd-items-loading.active{display:flex}',
      '.cd-items-spinner{width:32px;height:32px;border:3px solid var(--c-divider);border-top-color:var(--c-ui);border-radius:50%;animation:cd-spin .65s linear infinite}',
      /* Footer */
      '#cd-cart-footer{padding:10px 20px 10px;border-top:none;box-shadow:0 -4px 12px rgba(0,0,0,.04);flex-shrink:0;background:var(--c-bg-section)}',
      '#cd-cart-checkout{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:14px 16px;background:var(--c-navy);color:#fff;text-decoration:none;font-size:16px;font-weight:700;letter-spacing:.03em;border:none;border-radius:999px;cursor:pointer;box-sizing:border-box;transition:background .15s,box-shadow .15s}',
      '#cd-cart-checkout:hover{background:var(--c-navy-hover);box-shadow:0 4px 14px rgba(25,36,56,.35)}',
      '#cd-cart-checkout:active{transform:scale(0.98)}',
      '#cd-cart-trust{display:flex;flex-direction:row;gap:6px;margin:12px 0 0}',
      '.cd-trust-item{flex:1;display:flex;flex-direction:column;align-items:center;text-align:center;gap:6px;padding:10px 8px;font-size:10px;font-weight:600;color:#444;letter-spacing:.05em;text-transform:uppercase;line-height:1.3}',
      '.cd-trust-icon{width:32px;height:32px;flex-shrink:0;object-fit:contain}',
      /* Item card */
      '.cd-cart-item{display:flex;gap:12px;margin-bottom:0;padding:18px 0;border-bottom:1px solid var(--c-item-divider);position:relative;transition:background .15s ease}',
      '.cd-cart-item:last-child{border-bottom:none}',
      '.cd-cart-item.removing{opacity:0;transform:translateX(10px);pointer-events:none;transition:opacity .2s ease,transform .2s ease}',
      '.cd-item-thumb{width:80px;height:80px;flex-shrink:0;border-radius:6px;overflow:hidden;background:var(--c-stage);display:flex;align-items:center;justify-content:center}',
      '.cd-item-thumb img{width:100%;height:100%;object-fit:cover}',
      '.cd-item-thumb-placeholder{color:#ccc;font-size:22px}',
      '.cd-item-info{flex:1;min-width:0;padding-right:28px}',
      '.cd-item-title-row{position:relative;margin-bottom:2px}',
      '.cd-item-title{font-size:16px;font-weight:500;color:var(--c-ink);line-height:1.35;padding-right:70px}',
      '.cd-item-price{font-size:16px;font-weight:600;color:var(--c-ink);white-space:nowrap}',
      '.cd-item-title-row > .cd-item-price{position:absolute;top:0;right:0;text-align:right}',
      /* Price column when a campaign discount is active on this item */
      '.cd-item-price-wrap{display:flex;flex-direction:column;align-items:center;gap:1px;position:absolute;top:0;right:0;text-align:center}',
      '.cd-item-orig-price{font-size:13px;font-weight:400;color:#bbb;text-decoration:line-through;line-height:1.3}',
      /* Campaign name chip(s) below variant line */
      '.cd-item-campaigns{display:flex;flex-wrap:wrap;gap:4px;margin-bottom:4px}',
      '.cd-campaign-name{display:inline-flex;align-items:center;gap:3px;font-size:11px;color:var(--c-teal);font-weight:500;background:var(--c-teal-bg);border-radius:20px;padding:2px 8px}',
      '.cd-item-variant{font-size:14.5px;color:var(--c-sub);margin-bottom:4px}',
      '.cd-item-personalisation{font-size:13px;color:var(--c-mid);margin-bottom:2px;cursor:pointer;display:flex;align-items:center;gap:4px;user-select:none}',
      '.cd-personalisation-chevron{display:inline-block;width:5px;height:5px;border-right:1.5px solid #bbb;border-bottom:1.5px solid #bbb;transform:rotate(-45deg);transition:transform .2s ease;flex-shrink:0;margin-bottom:1px}',
      '.cd-item-personalisation.cd-pers-open .cd-personalisation-chevron{transform:rotate(45deg)}',
      /* Properties */
      '.cd-item-props{margin-bottom:6px;overflow:hidden;max-height:0;transition:max-height .2s ease}',
      '.cd-item-props.cd-props-open{max-height:200px}',
      '.cd-item-prop{font-size:13px;color:var(--c-meta);line-height:1.4;display:flex;gap:4px}',
      '.cd-prop-key{font-weight:400;color:var(--c-meta);flex-shrink:0}',
      '.cd-prop-check{color:var(--c-success);font-weight:700}',
      '.cd-prop-link{color:var(--c-teal);text-decoration:none;font-size:13px}',
      '.cd-prop-link:hover{text-decoration:underline}',
      /* Qty stepper — borderless fill */
      '.cd-item-actions{display:flex;align-items:center;margin-top:10px}',
      '.cd-qty-wrap{display:inline-flex;align-items:center;background:var(--c-surface);border-radius:6px;overflow:hidden}',
      '.cd-qty{background:transparent;border:none;width:38px;height:38px;cursor:pointer;font-size:16px;color:#444;display:inline-flex;align-items:center;justify-content:center;transition:background .1s ease;flex-shrink:0}',
      '.cd-qty:hover:not(.cd-qty--floor){background:var(--c-divider)}',
      '.cd-qty:active:not(.cd-qty--floor){transform:scale(0.88)}',
      '.cd-qty.cd-qty--floor{opacity:0.3!important;cursor:not-allowed!important;pointer-events:none!important}',
      '.cd-item-qty{min-width:32px;height:38px;text-align:center;font-size:14.5px;font-weight:500;color:var(--c-ink);line-height:38px}',
      /* Remove — absolute top-right, fades in on hover */
      '.cd-remove{position:absolute;top:18px;right:0;width:22px;height:22px;background:transparent;border:none;color:var(--c-ghost);cursor:pointer;font-size:13px;display:inline-flex;align-items:center;justify-content:center;padding:0;opacity:0;transition:opacity .15s ease,color .15s ease;line-height:1}',
      '.cd-cart-item:hover .cd-remove{opacity:1}',
      '.cd-remove:hover{color:var(--c-ink)}',
      '@media(max-width:768px){.cd-remove{opacity:1}}',
      /* Mobile floating card */
      '@media(max-width:768px){#cd-cart-panel{top:12px;right:12px;bottom:12px;width:calc(100vw - 24px);max-width:calc(100vw - 24px);height:auto;border-radius:10px 10px 16px 16px;box-shadow:0 8px 40px rgba(0,0,0,.22);overflow:hidden}}',
      '@media(max-width:768px){#cd-cart-drawer.open #cd-cart-panel{transform:translateX(0)}}',
      /* Empty + spinner */
      '#cd-cart-empty{text-align:center;padding:48px 20px;color:#aaa}',
      '#cd-cart-empty-icon{font-size:40px;margin-bottom:12px;opacity:.4}',
      '#cd-cart-empty p{font-size:13px;margin:0}',
      '.cd-spinner{text-align:center;padding:48px 0;color:#ccc;font-size:13px}',
      /* Engraving item — show as subordinate */
      '.cd-cart-item.cd-engraving-item .cd-item-title{font-weight:400;color:#666;font-size:12px}',
      '.cd-cart-item.cd-engraving-item .cd-item-thumb{opacity:.4}',
      /* Third-party suppression */
      '[id*="cowi"]{display:none!important;pointer-events:none!important}',
      /* Free shipping bar */
      '#cd-ship-bar{background:#fff;border-bottom:none;padding:0 20px 10px;flex-shrink:0}',
      '#cd-ship-bar-msg{font-size:13px;font-weight:400;color:#444;margin-bottom:8px;line-height:1.4;text-align:center}',
      '#cd-ship-bar-track{position:relative;height:8px;background:var(--c-divider);border-radius:4px;overflow:hidden}',
      /* Milestone notches on the multi-tier progress bar (gift tiers) */
      '.cd-ship-milestone{position:absolute;top:0;bottom:0;width:3px;background:#fff;transform:translateX(-50%);z-index:2;border-radius:1px;pointer-events:none}',
      /* Gift line colour swatches (reuse .cd-upsell-vpill look) */
      '.cd-gift-variants{display:flex;gap:6px;flex-wrap:wrap;align-items:center;min-height:28px}',
      '#cd-ship-bar-fill{height:100%;background:linear-gradient(90deg,var(--c-warm) 0%,var(--c-teal) 40%,var(--c-warm) 100%);background-size:200% 100%;border-radius:4px;width:0%;transition:width .4s ease;animation:cd-shimmer 2s infinite}',
      '#cd-ship-bar-fill.cd-unlocked{background:linear-gradient(90deg,var(--c-teal) 0%,var(--c-teal-light) 40%,var(--c-teal) 100%);background-size:200% 100%;animation:cd-shimmer 1.5s infinite}',
      '@keyframes cd-shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}',
      '@keyframes cd-confetti-fall{0%{transform:translateY(0) rotate(0deg);opacity:1}100%{transform:translateY(60px) rotate(720deg);opacity:0}}',
      /* Pricing block */
      '#cd-price-block{margin-bottom:12px}',
      '#cd-total-row{display:flex;justify-content:space-between;align-items:baseline}',
      '#cd-total-label{font-size:18px;font-weight:600;color:var(--c-ink)}',
      '#cd-total-prices{display:flex;flex-direction:row;align-items:baseline;gap:10px}',
      '#cd-original-price{display:none;font-size:14.5px;font-weight:400;color:var(--c-muted);text-decoration:line-through}',
      '#cd-total-price{font-size:22px;font-weight:700;color:var(--c-ink)}',
      '#cd-discount-subline{display:flex;justify-content:space-between;align-items:center;height:40px}',
      /* Discount badge */
      '.cd-discount-badge{display:inline-flex;align-items:center;gap:6px;background:var(--c-teal-bg);border-radius:20px;padding:4px 10px}',
      '.cd-discount-code{font-size:13px;font-weight:600;color:var(--c-teal);text-transform:uppercase;letter-spacing:.04em}',
      '#cd-discount-remove-btn{background:none;border:none;cursor:pointer;color:var(--c-teal);font-size:15px;line-height:1;padding:0;display:flex;align-items:center}',
      '#cd-discount-remove-btn:hover{color:var(--c-teal-hover)}',
      '#cd-discount-savings{font-size:14px;font-weight:500;color:var(--c-teal)}',
      /* Discount input */
      '#cd-discount-section{margin-bottom:14px;position:relative}',
      '#cd-discount-loading{display:none;position:absolute;inset:0;background:rgba(255,255,255,.72);border-radius:10px;align-items:center;justify-content:center;z-index:1}',
      '#cd-discount-loading.active{display:flex}',
      '.cd-disc-spinner{width:18px;height:18px;border:2px solid #e0e0e0;border-top-color:var(--c-ui);border-radius:50%;animation:cd-spin .65s linear infinite}',
      '@keyframes cd-spin{to{transform:rotate(360deg)}}',
      /* Discount input — full-width underline style */
      '#cd-discount-input-row{display:flex;align-items:center;width:100%;border-bottom:1px solid #e0e0e0;transition:border-color .2s}',
      '#cd-discount-input-row:focus-within{border-bottom-color:var(--c-teal)}',
      '#cd-discount-input{flex:1;height:38px;border:none;background:transparent;padding:0 0 0 2px;font-size:14px;color:var(--c-ink);outline:none;box-sizing:border-box}',
      '#cd-discount-input::placeholder{color:#bbb}',
      '#cd-discount-btn{background:transparent;border:none;color:var(--c-teal);font-size:13px;font-weight:600;cursor:pointer;padding:0;flex-shrink:0;transition:color .15s;letter-spacing:.02em}',
      '#cd-discount-btn:hover{color:var(--c-teal-hover)}',
      '#cd-discount-btn:disabled{color:#ccc;cursor:not-allowed}',
      '#cd-discount-msg{font-size:12px;margin-top:6px;padding:0 2px}',
      '#cd-discount-msg.cd-msg-error{color:#c0392b}',
      '#cd-discount-msg.cd-msg-loading{color:#888}',
      /* Upsell strip */
      '#cd-upsell-strip{margin:0 20px 5px;padding:12px 16px 14px;flex-shrink:0;background:#fff;border:1.5px dashed #18888c;border-radius:8px}',
      '#cd-upsell-label{font-size:15px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#18888c;margin-bottom:10px}',
      '#cd-upsell-card-wrap{display:flex;align-items:stretch;gap:12px}',
      '.cd-upsell-thumb{width:64px;height:64px;border-radius:6px;overflow:hidden;background:#f5f5f5;flex-shrink:0}',
      '.cd-upsell-thumb img{width:100%;height:100%;object-fit:cover}',
      '.cd-upsell-info{flex:1;min-width:0;display:flex;flex-direction:column;justify-content:space-between}',
      '.cd-upsell-title{font-size:14px;font-weight:500;color:#1a1a1a;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}',
      '.cd-upsell-right{display:flex;flex-direction:column;align-items:center;justify-content:space-between;flex-shrink:0}',
      '.cd-upsell-price{font-size:15px;font-weight:600;color:#1a1a1a;text-align:center}',
      '.cd-upsell-was{display:block;font-size:11px;font-weight:400;color:#bbb;text-decoration:line-through}',
      '.cd-upsell-add{background:#18888c;border:none;border-radius:999px;color:#fff;font-size:12px;font-weight:600;letter-spacing:.03em;padding:6px 14px;cursor:pointer;transition:background .15s,transform .1s ease;white-space:nowrap}',
      '.cd-upsell-add:hover{background:#126669;transform:scale(1.03)}',
      '.cd-upsell-add:active{transform:scale(0.96)}',
      '.cd-upsell-add-err{background:#c0392b!important}',
      /* Upsell skeleton */
      '.cd-upsell-skel{width:100%;height:80px;border-radius:6px;background:linear-gradient(90deg,#f0f0f0 25%,#e8e8e8 50%,#f0f0f0 75%);background-size:200% 100%;animation:cd-skel 1.2s ease-in-out infinite}',
      '@keyframes cd-skel{0%{background-position:200% 0}100%{background-position:-200% 0}}',
      /* Upsell variant swatches — 107px = 3 full pills + ~13px of 4th peeking */
      '.cd-upsell-variants-row{display:flex;align-items:center;gap:4px}',
      '.cd-upsell-variants{display:flex;flex-wrap:nowrap;gap:5px;width:107px;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch;flex-shrink:0;cursor:grab}',
      '.cd-upsell-variants.cd-dragging{cursor:grabbing;user-select:none}',
      '.cd-upsell-variants::-webkit-scrollbar{display:none}',
      '.cd-upsell-scroll-btn{flex-shrink:0;background:none;border:none;padding:0 2px;color:#bbb;font-size:18px;line-height:1;cursor:pointer;transition:color .1s}',
      '.cd-upsell-scroll-btn:hover{color:#555}',
      '.cd-upsell-vpill{width:28px;height:28px;border-radius:50%;border:2px solid transparent;background:#f2f2f2;cursor:pointer;padding:0;overflow:hidden;display:flex;align-items:center;justify-content:center;transition:border-color .1s,box-shadow .1s;flex-shrink:0}',
      '.cd-upsell-vpill:hover:not(.selected){border-color:#aaa}',
      '.cd-upsell-vpill.selected{border-color:#1a1a1a;box-shadow:0 0 0 2px #fff inset}',
    ].join('');
    document.head.appendChild(s);
  }

  function injectShell() {
    if (document.getElementById(DRAWER_ID)) return;
    var shell =
      '<div id="cd-cart-drawer">' +
        '<div id="cd-cart-overlay"></div>' +
        '<div id="cd-cart-panel">' +
          '<div id="cd-cart-header">' +
            '<span id="cd-cart-title">Cart<span id="cd-cart-count-badge">0</span></span>' +
            '<button id="cd-cart-close" aria-label="Close cart">&#x2715;</button>' +
          '</div>' +
          '<div id="cd-ship-bar">' +
            '<div id="cd-ship-bar-msg"></div>' +
            '<div id="cd-ship-bar-track"><div id="cd-ship-bar-fill"></div></div>' +
          '</div>' +
          '<div id="cd-items-wrap">' +
            '<div id="cd-cart-items"></div>' +
            '<div id="cd-items-loading"><div class="cd-items-spinner"></div></div>' +
          '</div>' +
          '<div id="cd-upsell-strip" style="display:none">' +
            '<div id="cd-upsell-label">You might also like</div>' +
            '<div id="cd-upsell-card-wrap"></div>' +
          '</div>' +
          '<div id="cd-cart-footer">' +
            '<div id="cd-price-block">' +
              '<div id="cd-total-row">' +
                '<span id="cd-total-label">Total</span>' +
                '<div id="cd-total-prices">' +
                  '<span id="cd-original-price"></span>' +
                  '<span id="cd-total-price"></span>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div id="cd-discount-section">' +
              '<div id="cd-discount-loading"><div class="cd-disc-spinner"></div></div>' +
              '<div id="cd-discount-subline" style="display:none">' +
                '<div class="cd-discount-badge">' +
                  '<span class="cd-discount-code" id="cd-discount-code-label"></span>' +
                  '<button id="cd-discount-remove-btn" aria-label="Remove discount">&#xD7;</button>' +
                '</div>' +
                '<span id="cd-discount-savings"></span>' +
              '</div>' +
              '<div id="cd-discount-input-row">' +
                '<input id="cd-discount-input" type="text" placeholder="Add discount code" autocomplete="off" autocapitalize="none" spellcheck="false">' +
                '<button id="cd-discount-btn" type="button">Apply</button>' +
              '</div>' +
              '<div id="cd-discount-msg" style="display:none"></div>' +
            '</div>' +
            '<a href="/checkout" id="cd-cart-checkout">' +
              '<span>CHECKOUT</span>' +
            '</a>' +
            '<div id="cd-cart-trust">' +
              '<div class="cd-trust-item">' +
                '<img class="cd-trust-icon" src="https://cdn.shopify.com/s/files/1/0409/1163/4582/files/Image_1_2x_ebe117da-508f-4ae5-bd42-0ca9f7fdc8c2.png?v=1721130433" alt="Australian Owned">' +
                'Australian Owned &amp; Operated' +
              '</div>' +
              '<div class="cd-trust-item">' +
                '<img class="cd-trust-icon" src="https://cdn.shopify.com/s/files/1/0409/1163/4582/files/Layer_1-2_2x_96bc48a1-f577-46db-89f5-1756996fb8a5.png?v=1721130851" alt="5 Year Warranty">' +
                '5 Year Warranty' +
              '</div>' +
              '<div class="cd-trust-item">' +
                '<img class="cd-trust-icon" src="https://cdn.shopify.com/s/files/1/0409/1163/4582/files/Layer_1-2_2x_67c7dbbc-4494-4d2a-a918-f8a79983c5c9.png?v=1721130907" alt="30 Day Free Returns">' +
                '30 Day Free Returns' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.insertAdjacentHTML('beforeend', shell);
    document.getElementById('cd-cart-close').addEventListener('click', closeDrawer);
    document.getElementById('cd-cart-overlay').addEventListener('click', closeDrawer);
    // Single persistent delegated listener — set up once, never re-added on re-render
    document.getElementById('cd-cart-items').addEventListener('click', function (e) {
      // Gift colour swatch — swap the gift line to the chosen variant
      var gift_pill = e.target.closest('.cd-gift-vpill');
      if (gift_pill) {
        if (gift_pill.classList.contains('selected')) return;
        var gift_wrap = gift_pill.closest('.cd-gift-variants');
        if (gift_wrap) {
          swapGiftVariant(
            gift_wrap.getAttribute('data-key'),
            gift_pill.getAttribute('data-variant-id'),
            gift_wrap.getAttribute('data-target')
          );
        }
        return;
      }
      var qty_btn = e.target.closest('.cd-qty');
      if (qty_btn) {
        if (qty_btn.disabled || qty_btn.classList.contains('cd-qty--floor')) return;
        var qty = parseInt(qty_btn.getAttribute('data-qty'), 10);
        var row = qty_btn.closest('.cd-cart-item');
        if (qty_btn.classList.contains('cd-qty-plus') && qty_btn.getAttribute('data-is-customised')) {
          if (row) row.querySelectorAll('.cd-qty').forEach(function (b) { b.disabled = true; b.style.opacity = '0.5'; });
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(qty_btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
          }).then(function () { render(); });
        } else {
          // Optimistic: paint instantly, sync to Shopify in the background
          optimisticChange(qty_btn.getAttribute('data-key'), qty, null);
        }
        return;
      }
      var rem_btn = e.target.closest('.cd-remove');
      if (rem_btn) {
        // Manual gift removal opts the customer out for this tier until they
        // drop below the threshold and cross it again
        var gift_target = rem_btn.getAttribute('data-gift-target');
        if (gift_target) { cdGiftOptOut[gift_target] = true; saveGiftOptOut(); }
        var rem_row = rem_btn.closest('.cd-cart-item');
        if (rem_row) rem_row.classList.add('removing');
        optimisticChange(rem_btn.getAttribute('data-key'), 0, rem_btn.getAttribute('data-engraving-key') || null);
        return;
      }
      var pers_toggle = e.target.closest('.cd-item-personalisation');
      if (pers_toggle) {
        var props_el = pers_toggle.nextElementSibling;
        if (props_el && props_el.classList.contains('cd-item-props')) {
          pers_toggle.classList.toggle('cd-pers-open');
          props_el.classList.toggle('cd-props-open');
        }
      }
    });

    // Upsell strip — delegated listener for variant pill selection and add-to-cart
    document.getElementById('cd-upsell-strip').addEventListener('click', function(e) {
      // Scroll arrows (‹ back, › forward) — one pill = 33px
      var scrollBtn = e.target.closest('.cd-upsell-scroll-btn');
      if (scrollBtn) {
        var varList = scrollBtn.classList.contains('cd-upsell-back')
          ? scrollBtn.nextElementSibling
          : scrollBtn.previousElementSibling;
        if (varList) varList.scrollLeft += scrollBtn.classList.contains('cd-upsell-back') ? -33 : 33;
        return;
      }
      // Variant pill selection
      var pill = e.target.closest('.cd-upsell-vpill');
      if (pill) {
        var ustrip = document.getElementById('cd-upsell-strip');
        ustrip.querySelectorAll('.cd-upsell-vpill').forEach(function(p){ p.classList.remove('selected'); });
        pill.classList.add('selected');
        var addBtn = ustrip.querySelector('.cd-upsell-add');
        if (addBtn) {
          addBtn.setAttribute('data-variant-id', pill.getAttribute('data-variant-id'));
          addBtn.style.opacity = '';
          addBtn.style.pointerEvents = '';
        }
        var priceEl = document.getElementById('cd-upsell-price-val');
        if (priceEl && document.getElementById('cd-upsell-strip').dataset.promoMode !== 'one-away') {
          priceEl.textContent = money(parseInt(pill.getAttribute('data-price'), 10));
        }
        var thumbImg = document.getElementById('cd-upsell-thumb-img');
        var newThumb = pill.getAttribute('data-thumb');
        if (thumbImg && newThumb) { thumbImg.src = newThumb; thumbImg.style.display = ''; }
        return;
      }
      // Add to cart
      var btn = e.target.closest('.cd-upsell-add');
      if (!btn || btn.disabled || !btn.getAttribute('data-variant-id')) return;
      btn.disabled = true;
      btn.style.opacity = '0.4';
      showItemsLoading(true);
      var fd = new FormData();
      fd.append('id', btn.getAttribute('data-variant-id'));
      fd.append('quantity', 1);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function(r){ if (!r.ok) throw new Error(); return r.json(); })
        .then(function(){ render(); })
        .catch(function(){
          showItemsLoading(false);
          btn.disabled = false;
          btn.style.opacity = '';
          btn.classList.add('cd-upsell-add-err');
          setTimeout(function(){ btn.classList.remove('cd-upsell-add-err'); }, 800);
        });
    });

    // Desktop drag-to-scroll on variant swatch row
    var _dragEl = null, _dragStartX = 0, _dragScrollStart = 0;
    document.getElementById('cd-upsell-strip').addEventListener('mousedown', function(e) {
      var vars = e.target.closest('.cd-upsell-variants');
      if (!vars) return;
      _dragEl = vars;
      _dragStartX = e.clientX;
      _dragScrollStart = vars.scrollLeft;
      vars.classList.add('cd-dragging');
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) {
      if (!_dragEl) return;
      _dragEl.scrollLeft = _dragScrollStart - (e.clientX - _dragStartX);
    });
    document.addEventListener('mouseup', function() {
      if (_dragEl) { _dragEl.classList.remove('cd-dragging'); _dragEl = null; }
    });
  }

  function openDrawer() {
    injectStyles();
    injectShell();
    var drawer = document.getElementById(DRAWER_ID);
    if (drawer.classList.contains('open')) {
      // Already open - a later background cart write (e.g. a second /cart/add
      // firing after the drawer already rendered) still needs to refresh the
      // contents, otherwise the drawer shows stale state until closed/reopened.
      render();
      return;
    }
    document.getElementById('cd-cart-items').innerHTML = '<div class="cd-spinner">Loading\u2026</div>';
    drawer.classList.add('open');
    // Desktop only: lock body scroll. On mobile/touch, the fixed full-screen overlay catches
    // all touch events — no lock needed. Setting body overflow on iOS causes scroll to break
    // after close because iOS re-evaluates scroll container via html (which has overflow-x:hidden in CSS).
    if (!('ontouchstart' in window)) {
      document.body.style.overflow = 'hidden';
    }
    render();
  }

  var cdJustClosed = false;

  function unlockScroll() {
    document.documentElement.style.overflow = '';
    // Use setProperty with !important — iOS Safari locks the entire viewport scroll when
    // overflow-x:hidden is set on html (Debutify base CSS, sheet 17). A plain assignment
    // loses to that lock; !important inline overrides it.
    document.documentElement.style.setProperty('overflow-y', 'auto', 'important');
    document.documentElement.classList.remove('js-drawer-open');
    document.documentElement.classList.remove('js-drawer-open-right');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove('js-drawer-open');
    document.body.classList.remove('js-drawer-open-right');
  }

  function closeDrawer() {
    var el = document.getElementById(DRAWER_ID);
    if (el) el.classList.remove('open');
    unlockScroll();
    cdJustClosed = true;
    setTimeout(function () { cdJustClosed = false; }, 500);
    // Deferred unlock: Debutify cart code runs async (setTimeout 0-100ms) after our close.
    // We can't catch it with watchOldDrawer because it may not touch body classes.
    // Running unlockScroll again at 150ms ensures any late Debutify scroll-lock is cleared.
    setTimeout(function () {
      var drawer = document.getElementById(DRAWER_ID);
      if (!drawer || !drawer.classList.contains('open')) {
        unlockScroll();
      }
    }, 150);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Format a line item property value for display. */
  function formatPropVal(v) {
    var s = String(v).trim();
    // Uploaded image URLs → "View design ↗" link
    if ((s.indexOf('http') === 0 || s.indexOf('//') === 0) && s.length > 60) {
      var esc = s.replace(/"/g, '&quot;');
      return '<a href="' + esc + '" target="_blank" rel="noopener" class="cd-prop-link">View design <svg width="9" height="9" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-bottom:1px"><path d="M2 8L8 2"/><path d="M4 2h4v4"/></svg></a>';
    }
    // Finish values → friendly casing
    if (s === 'uv') return 'Colour (UV)';
    if (s === 'metallic') return 'Metallic';
    return s;
  }

  /* Returns true for the DTC/B2B engraving service SKU.
     Engraving SKU has "_Customised Product" (title case) — set by customizer.
     The main product has "_customised_product" (lowercase) — different key, not an engraving item. */
  function isEngravingItem(item) {
    var props = item.properties || {};
    return !!(props['_Customised Product']);
  }

  function burstConfetti() {
    var bar = document.getElementById('cd-ship-bar');
    if (!bar) return;
    var colors = ['#e8b84b', 'var(--c-teal)', '#c0392b', '#2980b9', '#8e44ad'];
    bar.style.position = 'relative';
    for (var i = 0; i < 22; i++) {
      var p = document.createElement('div');
      p.style.cssText = 'position:absolute;width:7px;height:7px;border-radius:2px' +
        ';left:' + Math.random() * 100 + '%' +
        ';top:0' +
        ';background:' + colors[i % colors.length] +
        ';animation:cd-confetti-fall ' + (0.6 + Math.random() * 0.6).toFixed(2) + 's ' +
          (Math.random() * 0.4).toFixed(2) + 's ease-out both' +
        ';pointer-events:none';
      bar.appendChild(p);
      p.addEventListener('animationend', function () { this.remove(); });
    }
    if (navigator.vibrate) navigator.vibrate(80);
  }

  // ─── AOV GIFT TIERS ──────────────────────────────────────────────────────────
  // Auto-adds a free gift product when the qualifying cart total crosses a tier
  // threshold, and removes it again when the cart drops back below. Tiers are
  // configured in Theme Editor → "Cart drawer gift tiers" and injected by
  // theme.liquid as window.cdGiftTiers ([{target, handle, label}], cents, sorted).
  //
  // The gift line is added at FULL price carrying a hidden '_aov_gift' property;
  // a matching ACTIVE automatic BXGY discount in Admin zeroes it in cart and at
  // checkout (same pattern as the Father's Day ice tray). The gift's own value
  // never counts toward the threshold (see giftQualifyingTotal).
  var GIFT_PROP = '_aov_gift';
  var cdGiftOptOut = {};        // tier target → true when customer manually removed the gift
  try { cdGiftOptOut = JSON.parse(sessionStorage.getItem('cdGiftOptOut') || '{}') || {}; } catch (e) {}
  function saveGiftOptOut() {
    try { sessionStorage.setItem('cdGiftOptOut', JSON.stringify(cdGiftOptOut)); } catch (e) {}
  }
  var cdGiftFailed = {};        // tier target → true when auto-add failed (e.g. sold out) — prevents retry loops
  var cdGiftSyncing = false;    // suppress re-entrant syncs during our own cart writes
  var cdGiftProductCache = {};  // handle → Promise<product JSON>

  // Tiers with a sane config only — a blank/garbled threshold must never
  // become target 0 (which would gift every cart and zero the bar maths).
  function activeGiftTiers() {
    return (window.cdGiftTiers || []).filter(function (t) {
      return t && t.target > 0 && t.handle;
    });
  }

  function isGiftItem(item) {
    return !!((item.properties || {})[GIFT_PROP]);
  }

  // Line value the customer actually pays after EVERY discount touching the
  // line. final_line_price reflects automatic/Scripts product discounts but
  // NOT cart-level code allocations — those only appear in item.discounts.
  // Subtract the unreflected remainder so gift thresholds always measure the
  // real post-discount spend (proven live: a 20% code left final_line_price
  // untouched while allocating per line in item.discounts).
  function cdEffectiveLinePrice(i) {
    var flp = typeof i.final_line_price === 'number' ? i.final_line_price : i.line_price;
    var olp = typeof i.original_line_price === 'number' ? i.original_line_price : flp;
    var alloc = 0;
    (i.discounts || []).forEach(function (d) {
      alloc += (typeof d.amount === 'number' ? d.amount : 0);
    });
    var unreflected = alloc - (olp - flp); // what flp hasn't already absorbed
    if (unreflected > 0) flp -= unreflected;
    return flp > 0 ? flp : 0;
  }

  // Qualifying total = post-discount line totals, excluding gift lines and any
  // excluded handles (Theme Editor setting). An item another promo already made
  // free contributes $0 — matching how checkout computes the BXGY spend
  // requirement.
  function giftQualifyingTotal(cart) {
    var excl = String(window.cdGiftExcludeHandles || '').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);
    return cart.items.reduce(function (sum, i) {
      if (isGiftItem(i)) return sum;
      if (excl.indexOf(i.handle) !== -1) return sum;
      return sum + cdEffectiveLinePrice(i);
    }, 0);
  }

  function fetchGiftProduct(handle) {
    if (!cdGiftProductCache[handle]) {
      cdGiftProductCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return cdGiftProductCache[handle];
  }

  // Reconcile gift lines against tiers. Resolves to a fresh cart when a
  // mutation happened, or null when nothing changed. All writes run serially —
  // Shopify carts do not tolerate racing.
  function syncGiftTiers(cart) {
    if (cdGiftSyncing || window.b2bCompanyName) return Promise.resolve(null);
    var tiers = activeGiftTiers();
    var validTargets = {};
    tiers.forEach(function (t) { validTargets[String(t.target)] = true; });

    var qual = giftQualifyingTotal(cart);
    var adds = [], updates = {}, dirty = false;

    // Sweep pass: remove orphaned gift lines (tier disabled or threshold edited
    // since the line was added) and duplicate lines for the same tier. Runs even
    // with zero tiers configured — a stale gift must never reach checkout at
    // full price. keptLine holds the single surviving line per tier.
    var keptLine = {};
    cart.items.forEach(function (i) {
      var t = (i.properties || {})[GIFT_PROP];
      if (!t) return;
      if (!validTargets[t] || keptLine[t]) { updates[i.key] = 0; dirty = true; return; }
      keptLine[t] = i;
    });

    tiers.forEach(function (t) {
      var key = String(t.target);
      var line = keptLine[key];
      if (qual >= t.target) {
        if (!line && !cdGiftOptOut[key] && !cdGiftFailed[key]) adds.push(t);
        // Gift is always qty 1 — clamp anything else
        if (line && line.quantity > 1) { updates[line.key] = 1; dirty = true; }
      } else {
        if (cdGiftOptOut[key]) { delete cdGiftOptOut[key]; saveGiftOptOut(); } // dropping below re-arms the tier
        if (line) { updates[line.key] = 0; dirty = true; }
      }
    });
    if (!adds.length && !dirty) return Promise.resolve(null);
    cdGiftSyncing = true;
    var p = Promise.resolve();
    if (dirty) {
      p = p.then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          // A failed update must not loop render↔sync — bail out of this pass
          if (!r.ok) throw new Error('cart update failed');
        });
      });
    }
    adds.forEach(function (t) {
      p = p.then(function () { return fetchGiftProduct(t.handle); }).then(function (prod) {
        var variant = prod && prod.variants && prod.variants.filter(function (v) { return v.available; })[0];
        if (!variant) { cdGiftFailed[t.target] = true; return; }
        var props = {};
        props[GIFT_PROP] = String(t.target);
        props['_source'] = 'aov-gift';
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: props }] })
        }).then(function (r) { if (!r.ok) cdGiftFailed[t.target] = true; });
      });
    });
    return p
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) { cdGiftSyncing = false; return c; })
      .catch(function () { cdGiftSyncing = false; return null; });
  }

  // Swap the gift line to a different colour: add the new variant first, then
  // drop the old line (serial — never parallel cart writes). Re-entrancy guard
  // stops rapid double-clicks creating duplicate gift lines; if a duplicate
  // ever slips through anyway, syncGiftTiers' sweep pass removes it.
  function swapGiftVariant(oldKey, newVariantId, target) {
    if (cdGiftSyncing) return;
    showItemsLoading(true);
    cdGiftSyncing = true;
    var props = {};
    props[GIFT_PROP] = String(target);
    props['_source'] = 'aov-gift';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(newVariantId, 10), quantity: 1, properties: props }] })
    })
      .then(function (r) {
        // Add failed (e.g. colour sold out since paint) → keep the old line
        if (!r.ok) throw new Error('gift variant add failed');
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: oldKey, quantity: 0 })
        });
      })
      .then(function () { cdGiftSyncing = false; return render(); })
      .catch(function () { cdGiftSyncing = false; render(); });
  }

  // Paint colour swatches onto gift lines after render (product JSON is async).
  // Reuses .cd-upsell-vpill styling.
  function populateGiftSwatches() {
    document.querySelectorAll('.cd-gift-variants').forEach(function (el) {
      var handle = el.getAttribute('data-handle');
      if (!handle) return;
      fetchGiftProduct(handle).then(function (prod) {
        if (!prod || !prod.variants) return;
        var current = parseInt(el.getAttribute('data-current'), 10);
        // Co-brand variants (Bundaberg Rum) are licensed stock — never offered
        // as a free-gift colour choice (still shown if somehow already chosen).
        var choices = prod.variants.filter(function (v) {
          return (v.available || v.id === current) &&
                 (!/bundaberg/i.test(String(v.title)) || v.id === current);
        });
        if (choices.length < 2) return;
        el.innerHTML = choices.map(function (v) {
          var img = (v.featured_image && (v.featured_image.src || v.featured_image.url)) || '';
          img = img ? img.replace(/(\.[^.?]+)(\?.*)?$/, '_32x32_crop_center$1') : '';
          var title = String(v.title).replace(/"/g, '&quot;');
          var inner = img
            ? '<img src="' + img + '" width="24" height="24" alt="' + title + '" style="display:block;width:100%;height:100%;object-fit:cover">'
            : '<span style="font-size:9px;line-height:1;color:#666">' + String(v.title).charAt(0) + '</span>';
          return '<button class="cd-upsell-vpill cd-gift-vpill' + (v.id === current ? ' selected' : '') + '" data-variant-id="' + v.id + '" title="' + title + '">' + inner + '</button>';
        }).join('');
      });
    });
  }

  // ─── RECOMMENDATION RULES ────────────────────────────────────────────────────
  // Pin specific products to the front of the "You might also like" strip.
  // Rules are evaluated in ORDER — first match gets slot 1, second gets slot 2.
  //
  // To add a rule, append an entry to CD_UPSELL_RULES below:
  //   {
  //     handle : 'product-handle',          // Shopify product handle (string)
  //     test   : function(items) { ... }    // return true to activate this rule
  //   }
  //
  // 'items' = visible (non-engraving) cart items. Useful fields per item:
  //   item.product_type   e.g. 'Insulated Bottle'
  //   item.product_title  e.g. 'Insulated Bottle 1L'
  //   item.handle         e.g. '1l'
  //   item.sku            e.g. 'H_ALMD_1L'
  //   item.product_id     numeric Shopify product ID
  //
  // If a pinned product is already in the cart it is skipped automatically
  // and the next rule (or Shopify's recommendations) takes over.
  // ─────────────────────────────────────────────────────────────────────────────

  // Master switch for the 3-for-2 promo strip below. Flip to true to re-enable —
  // BUY_X_GET_Y_IDS and getPromoBottleTarget stay intact while this is false.
  var CD_PROMO_3FOR2_ENABLED = false;

  // Products eligible for the 3-for-2 promotion, in priority order.
  // Identified by product_id (stable — never changes even if handle or title is edited).
  // Exclusions: Bundles (product_type), Bundaberg/Bundy (title), car cupholder, shoulder straps, 3pk.
  var BUY_X_GET_Y_IDS = [
    5298283610262,  // Insulated Stubby Holder
    7093177712837,  // Insulated Bottle 1L
    7407543779525,  // Insulated Bottle 2L
    8376842125509,  // Ice Tray 1L & 2L
    8208157802693,  // Ice Tray 4L & 6L
    8293363810501,  // 1L Silicone Grip
    8293364105413,  // 2L Silicone Grip
    7407547023557,  // Insulated Hydro Jug 4L
    8095656640709,  // Insulated Hydro Jug 6L
    8738477899973,  // Stainless Steel Straw
    7556025614533,  // Lunch PAL
    7001515065541,  // Insulated Cooler Bag 15L
    7377427235013,  // Insulated Cooler Backpack 20L
    6698293067973,  // Insulated Cooler Backpack 35L
    7092974846149,  // DrainPro 35L Backpack
    8432338763973,  // Insulated RidePal 6L
    7498728276165,  // 6PACKPAL
    8095688261829,  // Insulated Wine Holder
    8293365547205,  // 1L & 2L Smart Lid
    7669526560965,  // 4L & 6L HydroJUG Lid
    8424305787077,  // 4L Bottle Sling
    8424431583429   // 6L Bottle Sling
  ];

  // 3-for-2 promotion: find the highest-priority eligible product in the cart.
  // Priority 1: "1-away" (count=2) before "2-away" (count=1).
  // Tie-break within same priority: order defined by BUY_X_GET_Y_IDS above.
  // Returns { handle, count } or null if no actionable product found.
  function getPromoBottleTarget(items) {
    var idMap = {};
    items.forEach(function(i) {
      if (BUY_X_GET_Y_IDS.indexOf(i.product_id) === -1) return;
      if (!idMap[i.product_id]) idMap[i.product_id] = { count: 0, handle: i.handle };
      idMap[i.product_id].count += i.quantity;
    });
    // Iterate in canonical priority order (BUY_X_GET_Y_IDS index)
    var oneAway = null, twoAway = null;
    BUY_X_GET_Y_IDS.forEach(function(pid) {
      var info = idMap[pid];
      if (!info) return;
      if (info.count === 2 && !oneAway) oneAway = info;   // 1 more completes the deal
      if (info.count === 1 && !twoAway) twoAway = info;   // 2 more needed
    });
    return oneAway || twoAway || null;
  }

  var CD_UPSELL_RULES = [
    {
      // 1L & 2L bottles → 1L & 2L ice tray
      handle: 'ice-tray-1l-2l-size',
      test: function(items) {
        return items.some(function(i) {
          return i.product_type === 'Insulated Bottle' && /\b[12]L\b/i.test(i.product_title);
        });
      }
    },
    {
      // 4L & 6L jugs → 4L & 6L ice tray
      handle: 'silicon-ice-mold-aqua',
      test: function(items) {
        return items.some(function(i) {
          return i.product_type === 'Insulated Hydro Jug' && /\b[46]L\b/i.test(i.product_title);
        });
      }
    }
    // ↓ Add more rules here
  ];

  function loadUpsell(cart) {
    var strip = document.getElementById('cd-upsell-strip');
    if (!strip) return;
    var visible = cart.items.filter(function(i){ return !isEngravingItem(i); });
    if (!visible.length) { strip.style.display = 'none'; return; }

    // One skeleton covers the whole strip (label + card) — shell re-injected on resolve
    strip.innerHTML = '<div class="cd-upsell-skel"></div>';
    strip.style.display = '';

    var inCartIds = {};
    cart.items.forEach(function(i){ inCartIds[i.product_id] = true; });

    // Resolve image URL regardless of whether it's a string or {src,url} object
    function imgUrl(val, size) {
      if (!val) return '';
      var u = typeof val === 'string' ? val : (val.src || val.url || '');
      return u ? u.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + '$1') : '';
    }

    // Gift-gap targeting: when a gift tier is within reach, the strip leads with
    // the cheapest single item that closes the gap ("one add unlocks the gift").
    var nextGiftGap = 0, nextGiftLabel = '';
    if (!window.b2bCompanyName) {
      var giftTiersU = activeGiftTiers();
      var qualU = giftQualifyingTotal(cart);
      for (var gi = 0; gi < giftTiersU.length; gi++) {
        if (qualU < giftTiersU[gi].target) {
          nextGiftGap = giftTiersU[gi].target - qualU;
          nextGiftLabel = giftTiersU[gi].label;
          break;
        }
      }
    }

    // Promotion rule fires first — suppresses existing rules entirely when active
    // B2B company contacts (co-brand + wholesale) skip the 3-for-2 promo
    var promoTarget = (CD_PROMO_3FOR2_ENABLED && !window.b2bCompanyName) ? getPromoBottleTarget(visible) : null;
    var promoHandle = promoTarget ? promoTarget.handle : null;
    // count=2 → 1 more needed (one-away); count=1 → 2 more needed (two-away)
    var promoMode = promoTarget ? (promoTarget.count === 2 ? 'one-away' : 'two-away') : null;

    // Fetch disable_variant metafield values via the Liquid metafields endpoint.
    // Returns an object keyed by variant ID; truthy = disabled.
    function fetchDisabledVariants(handle) {
      return fetch('/products/' + handle + '?view=metafields')
        .then(function(r) { return r.json(); })
        .then(function(arr) {
          var disabled = {};
          (arr || []).forEach(function(v) { if (v.disable) disabled[v.id] = true; });
          return disabled;
        })
        .catch(function() { return {}; });
    }

    // Mark disabled-by-metafield variants as unavailable in-place.
    // If none remain available, sets product.available = false so products.find() skips it.
    function applyDisabledVariants(product, disabledMap) {
      if (!product) return;
      var anyAvailable = false;
      product.variants.forEach(function(v) {
        if (disabledMap[v.id]) v.available = false;
        if (v.available) anyAvailable = true;
      });
      if (!anyAvailable) product.available = false;
    }

    // /products/{handle}.js returns price in cents, accurate variant.available booleans,
    // and featured_image already populated per variant.
    // disable_variant metafields are applied in parallel so pinned products are fully
    // normalised before products.find() runs.
    function fetchPinnedProduct(handle) {
      return Promise.all([
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(d) { return d || null; })
          .catch(function() { return null; }),
        fetchDisabledVariants(handle)
      ]).then(function(results) {
        var p = results[0];
        if (p) applyDisabledVariants(p, results[1]);
        return p;
      }).catch(function() { return null; });
    }

    // Fetch pinned products (rules that fire) + Shopify recommendations in parallel
    // When promo fires, skip CD_UPSELL_RULES so the promo product leads exclusively
    var matchedRules = promoHandle ? [] : CD_UPSELL_RULES.filter(function(rule) { return rule.test(visible); });
    var promoFetch      = promoHandle ? [fetchPinnedProduct(promoHandle)] : [];
    var pinnedFetches   = promoFetch.concat(matchedRules.map(function(rule) {
      return fetchPinnedProduct(rule.handle);
    }));
    var recoFetch = fetch('/recommendations/products.json?product_id=' + visible[0].product_id + '&limit=6')
      .then(function(r) { return r.json(); })
      .then(function(d) { return d.products || []; })
      .catch(function() { return []; });

    // Gap mode: products already in the cart are candidates too ("add another
    // 1L bottle" is often the natural gap-closer). Shopify recommendations
    // never include the cart's own products, so fetch them explicitly.
    if (nextGiftGap > 0 && !promoHandle) {
      var seenCartHandles = {};
      visible.forEach(function (i) {
        if (i.handle && !seenCartHandles[i.handle]) {
          seenCartHandles[i.handle] = true;
          pinnedFetches.push(fetchPinnedProduct(i.handle));
        }
      });
      // Guarantee the small bottles are always in the candidate pool — Shopify's
      // recommendations often omit them (e.g. on a 4L jug cart), leaving only
      // expensive closers. Fetches are cached, so this is cheap.
      ['1l', '2l'].forEach(function (h) {
        if (!seenCartHandles[h]) { seenCartHandles[h] = true; pinnedFetches.push(fetchPinnedProduct(h)); }
      });
      // A jug owner's most coherent closer is their jug's own sling.
      if (seenCartHandles['insulated-water-jug-3-8l'] && !seenCartHandles['4l-hydro-jug-bottle-sling-black']) {
        pinnedFetches.push(fetchPinnedProduct('4l-hydro-jug-bottle-sling-black'));
      }
      if (seenCartHandles['insulated-hydro-jug-6l'] && !seenCartHandles['6l-hydro-jug-bottle-sling']) {
        pinnedFetches.push(fetchPinnedProduct('6l-hydro-jug-bottle-sling'));
      }
    }

    Promise.all([recoFetch].concat(pinnedFetches))
      .then(function(results) {
        var recoProducts = results[0];
        var pinnedProducts = results.slice(1).filter(Boolean);
        // Pinned products lead; Shopify's picks fill the rest
        var products = pinnedProducts.concat(recoProducts);

        // --- DIAGNOSTIC LOGS (remove once race condition / stale-cart root cause confirmed) ---
        // --------------------------------------------------------------------------------------

        var SERVICE_RE = /customis|upload|engrav|service/i;
        // Never recommend a gift-tier product — the gift engine owns those
        var giftHandles = {};
        (window.cdGiftTiers || []).forEach(function (t) { giftHandles[t.handle] = true; });
        // Products never shown in the upsell strip (by product ID)
        var UPSELL_BLOCK_IDS = [
          8738477899973,  // Stainless Steel Straw
          7498728276165,  // 6PACKPAL
          8751068872901,  // 1L Bundaberg Rum Bottle (co-brand — never a DTC upsell)
          8751087616197,  // Bundaberg Rum Drink Cooler (co-brand)
          8751327805637,  // 4L Bundaberg Rum Jug (co-brand)
          8751380103365   // Bundaberg Rum Cooler Backpack 35L (co-brand)
        ];
        function upsellBlocked(p) { return UPSELL_BLOCK_IDS.indexOf(p.id) !== -1; }

        // Low-margin accessories are never SUGGESTED as gap-closers (the margin
        // on these doesn't cover the gift's cost, so steering shoppers to them
        // loses money). They still count toward thresholds and still appear as
        // regular upsells — this only shapes the recommendation.
        var GAP_CLOSER_BLOCK_IDS = [
          8376842125509,  // Ice Tray 1L & 2L
          8208157802693,  // Ice Tray 4L & 6L
          8293363810501,  // 1L Silicone Grip
          8293364105413,  // 2L Silicone Grip
          8293365547205,  // 1L & 2L Smart Lid
          7669526560965,  // 4L & 6L HydroJUG Lid
          8432339222725,  // Car Cupholder For 1L Bottle
          7251778240709   // 15L Shoulder straps x2
        ];

        // Gap-closer takes the lead slot: cheapest available product whose price
        // covers the remaining distance to the next gift tier. Excluded handles
        // can't close the gap (their value doesn't count toward thresholds).
        var isGapClose = false, gapPickId = null;
        if (nextGiftGap > 0 && !promoHandle) {
          var gapExcl = String(window.cdGiftExcludeHandles || '').split(',')
            .map(function (s) { return s.trim(); }).filter(Boolean);
          // Gap-closer rule (agreed 19-07): the CHEAPEST PREFERRED product that
          // covers the gap wins. Preferred = core bottles (always a coherent
          // add — "one for you / the wife / the kids") plus, when the cart has
          // a 4L/6L jug, that jug's own sling (its natural accessory). Other
          // products only appear when nothing preferred can cover the gap.
          var CORE_BOTTLE_IDS = [
            7093177712837,  // Insulated Bottle 1L
            7407543779525,  // Insulated Bottle 2L
            7407547023557,  // Insulated Hydro Jug 4L
            8095656640709   // Insulated Hydro Jug 6L
          ];
          if (inCartIds[7407547023557]) CORE_BOTTLE_IDS.push(8424305787077); // 4L in cart -> 4L sling preferred
          if (inCartIds[8095656640709]) CORE_BOTTLE_IDS.push(8424431583429); // 6L in cart -> 6L sling preferred
          var closers = products.filter(function (p) {
            return p.available && p.price >= nextGiftGap &&
                   !SERVICE_RE.test(p.title) && !SERVICE_RE.test(p.handle) &&
                   !giftHandles[p.handle] && !upsellBlocked(p) &&
                   GAP_CLOSER_BLOCK_IDS.indexOf(p.id) === -1 &&
                   gapExcl.indexOf(p.handle) === -1;
          }).sort(function (a, b) {
            var aB = CORE_BOTTLE_IDS.indexOf(a.id) !== -1 ? 0 : 1;
            var bB = CORE_BOTTLE_IDS.indexOf(b.id) !== -1 ? 0 : 1;
            if (aB !== bB) return aB - bB;
            return a.price - b.price;
          });
          if (closers.length) {
            isGapClose = true;
            gapPickId = closers[0].id;
            products = [closers[0]].concat(products.filter(function (p) { return p.id !== gapPickId; }));
          }
        }

        var product = products.find(function(p){
          var isPromo = promoHandle && p.handle === promoHandle;
          // inCartIds bypass for promo and the gap-closer — both may recommend more of an in-cart item
          return (isPromo || p.id === gapPickId || !inCartIds[p.id]) && p.available && !SERVICE_RE.test(p.title) && !SERVICE_RE.test(p.handle) && !giftHandles[p.handle] && !upsellBlocked(p);
        });
        if (!product) { strip.style.display = 'none'; return; }

        // Pinned products already had disable_variant applied inside fetchPinnedProduct.
        // For reco products (not pinned), apply it now for the one product we'll show.
        var pinnedSet = {};
        pinnedProducts.forEach(function(p) { if (p) pinnedSet[p.handle] = true; });
        var mfPromise = pinnedSet[product.handle]
          ? Promise.resolve()
          : fetchDisabledVariants(product.handle).then(function(dm) { applyDisabledVariants(product, dm); });

        return mfPromise.then(function() {
          if (!product.available) { strip.style.display = 'none'; return; }

          var hasVariants = product.variants.length > 1 && product.variants[0].title !== 'Default Title';
          var availableVariants = hasVariants ? product.variants.filter(function(vv){ return vv.available; }) : [];
          var defaultVariant = availableVariants[0] || product.variants[0];

          // Thumbnail: default variant image → product image → blank
          var thumbSrc = imgUrl(defaultVariant.featured_image, '120x120') ||
                         imgUrl(product.images && product.images[0], '120x120') ||
                         imgUrl(product.featured_image, '120x120');

          var pillsHtml = '';
          if (hasVariants) {
            var pills = availableVariants.map(function(vv, idx){
              var swatchSrc = imgUrl(vv.featured_image, '32x32_crop_center');
              var thumbData = imgUrl(vv.featured_image, '120x120') || thumbSrc;
              var inner = swatchSrc
                ? '<img src="' + swatchSrc + '" width="24" height="24" alt="' + vv.title.replace(/"/g,'&quot;') + '" style="display:block;width:100%;height:100%;object-fit:cover">'
                : '<span style="font-size:9px;line-height:1;color:#666">' + vv.title.charAt(0) + '</span>';
              return '<button class="cd-upsell-vpill' + (idx === 0 ? ' selected' : '') + '" data-variant-id="' + vv.id + '" data-price="' + vv.price + '" data-thumb="' + thumbData.replace(/"/g,'&quot;') + '" title="' + vv.title.replace(/"/g,'&quot;') + '">' + inner + '</button>';
            }).join('');
            // Scroll arrow only shown when more than 3 variants
            var hasMore = availableVariants.length > 3;
            var backBtn = hasMore ? '<button class="cd-upsell-scroll-btn cd-upsell-back" aria-label="Previous colours">&#8249;</button>' : '';
            var fwdBtn  = hasMore ? '<button class="cd-upsell-scroll-btn cd-upsell-fwd"  aria-label="Next colours">&#8250;</button>' : '';
            pillsHtml = '<div class="cd-upsell-variants-row">' + backBtn + '<div class="cd-upsell-variants">' + pills + '</div>' + fwdBtn + '</div>';
          }

          // Re-inject label + card-wrap shell now that skeleton is done
          strip.innerHTML = '<div id="cd-upsell-label"></div><div id="cd-upsell-card-wrap"></div>';
          var wrap = document.getElementById('cd-upsell-card-wrap');

          wrap.innerHTML =
            '<div class="cd-upsell-thumb"><img id="cd-upsell-thumb-img" src="' + thumbSrc + '" alt="' + product.title.replace(/"/g,'&quot;') + '" width="64" height="64"' + (thumbSrc ? '' : ' style="visibility:hidden"') + '></div>' +
            '<div class="cd-upsell-info">' +
              '<div class="cd-upsell-title">' + product.title + '</div>' +
              pillsHtml +
            '</div>' +
            '<div class="cd-upsell-right">' +
              '<div class="cd-upsell-price" id="cd-upsell-price-val">' + (promoMode === 'one-away' ? '<span class="cd-upsell-was">' + money(defaultVariant.price) + '</span>Free' : money(defaultVariant.price)) + '</div>' +
              '<button class="cd-upsell-add" data-variant-id="' + defaultVariant.id + '" aria-label="Add ' + product.title.replace(/"/g,'&quot;') + ' to cart">Add &#8594;</button>' +
            '</div>';

          // Update label and store promoMode for pill click handler
          var labelEl = document.getElementById('cd-upsell-label');
          if (labelEl) {
            if (promoMode === 'two-away') labelEl.textContent = 'BUY 2, GET 1 FREE';
            else if (promoMode === 'one-away') labelEl.textContent = 'ADD IT FOR FREE!';
            else if (isGapClose && product.id === gapPickId) {
              // List EVERY milestone this one add would unlock (shipping + gift tiers)
              var unlocks = [];
              if (window.cdFreeShipTarget && cart.total_price < window.cdFreeShipTarget &&
                  cart.total_price + product.price >= window.cdFreeShipTarget) {
                unlocks.push('FREE SHIPPING');
              }
              var qNow = giftQualifyingTotal(cart);
              activeGiftTiers().forEach(function (t) {
                if (qNow < t.target && qNow + product.price >= t.target) unlocks.push('FREE ' + t.label.toUpperCase());
              });
              labelEl.textContent = unlocks.length ? 'ADD THIS — UNLOCK ' + unlocks.join(' + ') + '!' : 'YOU MIGHT ALSO LIKE';
            }
            else labelEl.textContent = 'YOU MIGHT ALSO LIKE';
          }
          strip.dataset.promoMode = promoMode || '';
        });
      })
      .catch(function(){ strip.style.display = 'none'; });
  }

  // Multi-milestone progress bar: free shipping + gift tiers on one track.
  // Shipping progress is measured on cart.total_price (matches checkout's
  // free-shipping condition); gift progress on the qualifying total.
  var cdMilestoneUnlocked = {};

  function updateShipBar(cart) {
    var bar = document.getElementById('cd-ship-bar');
    if (!bar) return;
    var milestones = [];
    if (window.cdFreeShipTarget) {
      milestones.push({ target: window.cdFreeShipTarget, type: 'ship', name: 'FREE shipping' });
    }
    if (!window.b2bCompanyName) {
      activeGiftTiers().forEach(function (t) {
        milestones.push({ target: t.target, type: 'gift', name: 'FREE ' + t.label });
      });
    }
    milestones.sort(function (a, b) { return a.target - b.target; });
    if (!milestones.length) { bar.style.display = 'none'; return; }
    bar.style.display = '';

    var qual = giftQualifyingTotal(cart);
    function progressOf(m) { return m.type === 'ship' ? cart.total_price : qual; }

    var max   = milestones[milestones.length - 1].target;
    var fill  = document.getElementById('cd-ship-bar-fill');
    var msg   = document.getElementById('cd-ship-bar-msg');
    var track = document.getElementById('cd-ship-bar-track');

    // Milestone marker dots (only when more than one milestone). Rebuilt only
    // when the milestone set changes, so the fill transition stays smooth.
    if (track) {
      var sig = milestones.map(function (m) { return m.type + m.target; }).join('|');
      if (track.getAttribute('data-msig') !== sig) {
        track.querySelectorAll('.cd-ship-milestone').forEach(function (d) { d.remove(); });
        if (milestones.length > 1) {
          milestones.forEach(function (m) {
            if (m.target === max) return; // the end of the bar IS the last milestone
            var dot = document.createElement('div');
            dot.className = 'cd-ship-milestone';
            dot.style.left = Math.min(m.target / max * 100, 100) + '%';
            track.appendChild(dot);
          });
        }
        track.setAttribute('data-msig', sig);
      }
    }

    // Fill % tracks the next locked milestone's own progress measure
    var next = null;
    for (var i = 0; i < milestones.length; i++) {
      if (progressOf(milestones[i]) < milestones[i].target) { next = milestones[i]; break; }
    }
    var fillProgress = next ? progressOf(next) : max;
    if (fill) {
      fill.style.width = Math.min(fillProgress / max * 100, 100) + '%';
      fill.classList.toggle('cd-unlocked', !next);
    }

    // Confetti on every fresh unlock
    var burst = false;
    milestones.forEach(function (m) {
      var k = m.type + m.target;
      var unlocked = progressOf(m) >= m.target;
      if (unlocked && cdMilestoneUnlocked[k] === false) burst = true;
      cdMilestoneUnlocked[k] = unlocked;
    });
    if (burst) burstConfetti();

    if (msg) {
      if (!next) {
        var last = milestones[milestones.length - 1];
        msg.innerHTML = '<strong>' + last.name + '</strong> unlocked!';
      } else if (next.type === 'ship') {
        msg.innerHTML = 'You\'re <strong>' + money(next.target - progressOf(next)) + '</strong> away from <strong>FREE</strong> shipping!';
      } else {
        msg.innerHTML = 'You\'re <strong>' + money(next.target - progressOf(next)) + '</strong> away from a <strong>' + next.name + '</strong>! &#127873;';
      }
    }
  }

  function showDiscountMsg(text, cls) {
    var msg = document.getElementById('cd-discount-msg');
    if (!msg) return;
    msg.textContent = text;
    msg.className = cls;
    msg.style.display = text ? '' : 'none';
  }

  function showDiscountLoading(on) {
    var el = document.getElementById('cd-discount-loading');
    if (el) el.classList.toggle('active', on);
  }

  function showItemsLoading(on) {
    var el = document.getElementById('cd-items-loading');
    if (el) el.classList.toggle('active', on);
  }

  function applyDiscount() {
    var input = document.getElementById('cd-discount-input');
    var btn   = document.getElementById('cd-discount-btn');
    var code  = input ? input.value.trim() : '';
    if (!code) return;
    if (btn) btn.disabled = true;
    showDiscountLoading(true);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        showDiscountLoading(false);
        var applied = cart.cart_level_discount_applications || [];
        if (applied.length === 0) {
          showDiscountMsg('Invalid or expired discount code.', 'cd-msg-error');
          if (btn) btn.disabled = false;
          return render(cart);
        } else {
          showDiscountMsg('', '');
          if (btn) btn.disabled = false;
          // /cart/update.js response is immediate — discount totals may not be calculated yet.
          // Fetch fresh /cart.js so render() gets the fully-processed discount data.
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { return render(c); });
        }
      })
      .catch(function () {
        showDiscountLoading(false);
        showDiscountMsg('Something went wrong. Try again.', 'cd-msg-error');
        if (btn) btn.disabled = false;
      });
  }

  function removeDiscount() {
    // Optimistic UI clear for instant feedback
    var discountSubline  = document.getElementById('cd-discount-subline');
    var discountInputRow = document.getElementById('cd-discount-input-row');
    var discountInput    = document.getElementById('cd-discount-input');
    if (discountSubline)  discountSubline.style.display  = 'none';
    if (discountInputRow) discountInputRow.style.display = '';
    if (discountInput)    discountInput.value = '';
    showDiscountMsg('', '');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function (r) { return r.json(); }).then(function (cart) { return render(cart); });
  }

  function render(cartData, opts) {
    var optimistic = !!(opts && opts.optimistic);
    var cartP = cartData
      ? Promise.resolve(cartData)
      : fetch('/cart.js').then(function (r) { return r.json(); });
    // A code that arrived on an empty cart applies as soon as items exist —
    // never on optimistic paints (no network on the tap path).
    if (!optimistic) cartP = cartP.then(cdApplyDeferredDiscount);
    // Fetch Liquid discount applications in parallel — covers Shopify Scripts campaigns
    // that /cart.js AJAX does not expose (Scripts modify line prices directly).
    // Optimistic paints reuse the cached copy: no network on the tap path.
    var discP = optimistic
      ? Promise.resolve(cdLastLiquidDiscounts)
      : fetch('/?sections=cart-discounts')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var raw = (s && s['cart-discounts']) || '[]';
        try { return JSON.parse(raw.trim()); } catch (e) { return []; }
      })
      .catch(function () { return []; });
    return Promise.all([cartP, discP]).then(function (res) {
      var cart = res[0];
      var liquidDiscounts = res[1];
      cdLastLiquidDiscounts = liquidDiscounts;
      var engravingItems = cart.items.filter(isEngravingItem);
      var visibleItems   = cart.items.filter(function (i) { return !isEngravingItem(i); });

        // Auto-cleanup orphaned engraving SKUs (safety net — catches any removal failure)
        var visibleCustIds = {};
        visibleItems.forEach(function (i) {
          var id = (i.properties || {})['_cust_id'];
          if (id) visibleCustIds[id] = true;
        });
        var orphans = engravingItems.filter(function (e) {
          var id = (e.properties || {})['_cust_id'];
          return !id || !visibleCustIds[id];
        });
        if (!optimistic && orphans.length > 0) {
          var orphanUpdates = {};
          orphans.forEach(function (e) { orphanUpdates[e.key] = 0; });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: orphanUpdates })
          }).then(function (r) { return r.json(); }).then(function (c) { return render(c); });
        }

        // AOV gift tiers: reconcile before painting — a cart mutation re-renders
        // with the fresh cart (sync is a no-op on the second pass). Optimistic
        // paints NEVER write to the cart: gift sync waits for the reconcile
        // render after the debounced update lands.
        var giftP = optimistic ? Promise.resolve(null) : syncGiftTiers(cart);
        return giftP.then(function (giftCart) {
        if (giftCart) return render(giftCart);
        cdLastCart = cart;

        var count = visibleItems.reduce(function (n, i) { return n + i.quantity; }, 0);

        // Badge
        var badge = document.getElementById('cd-cart-count-badge');
        if (badge) badge.textContent = count;

        // ── Discount code handling (user-applied codes only) ─────────────────────
        var priceEl       = document.getElementById('cd-total-price');
        var origPriceEl   = document.getElementById('cd-original-price');
        // Prefer Liquid section data (campaign names for Scripts cart-level codes).
        // Fall back to AJAX data when section fetch fails.
        var discounts = liquidDiscounts.length > 0
          ? liquidDiscounts
          : (cart.cart_level_discount_applications || []);
        var discountSubline   = document.getElementById('cd-discount-subline');
        var discountInputRow  = document.getElementById('cd-discount-input-row');
        var discountCodeLabel = document.getElementById('cd-discount-code-label');
        var discountSavings   = document.getElementById('cd-discount-savings');

        if (discounts.length > 0) {
          var disc    = discounts[0];
          var savings = disc.total_allocated_amount || 0;
          if (priceEl)     priceEl.textContent    = money(cart.total_price);
          if (origPriceEl) {
            origPriceEl.textContent   = money(cart.original_total_price);
            origPriceEl.style.display = 'inline';
          }
          if (discountCodeLabel) discountCodeLabel.textContent = disc.title;
          if (discountSavings)   discountSavings.textContent   = '-' + money(savings);
          if (discountSubline)   discountSubline.style.display  = '';
          if (discountInputRow)  discountInputRow.style.display = 'none';
        } else {
          if (priceEl) priceEl.textContent = money(cart.total_price);
          // Show strikethrough on total when campaign discounts are reducing it
          // (no code active, but Scripts/automatic have lowered line prices)
          if (origPriceEl) {
            if (cart.original_total_price > cart.total_price) {
              origPriceEl.textContent   = money(cart.original_total_price);
              origPriceEl.style.display = 'inline';
            } else {
              origPriceEl.style.display = 'none';
            }
          }
          if (discountSubline)  discountSubline.style.display  = 'none';
          if (discountInputRow) discountInputRow.style.display = '';
          showDiscountMsg('', '');
        }
        // ─────────────────────────────────────────────────────────────────────────

        // Sync external cart count badges
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = count;
        });

        // Build item HTML
        // engravingMap: keyed by _cust_id so each visible item can find its linked
        // engraving SKU. Arrays: automatic discounts (e.g. first-engraving-free)
        // can SPLIT one surcharge line into a discounted line + a full-price line
        // sharing the same _cust_id.
        var engravingMap = {};
        engravingItems.forEach(function (e) {
          var id = (e.properties || {})['_cust_id'];
          if (id) (engravingMap[id] = engravingMap[id] || []).push(e);
        });

        var PROP_LABELS = {
          'FRONT GALLERY IMAGE NAME': 'Design',
          'BACK GALLERY IMAGE NAME': 'Back design',
          'FRONT NAME': 'Text',
          'BACK NAME': 'Back text',
          'B2B FRONT FINISH': 'Finish',
          'B2B BACK FINISH': 'Back finish',
          'B2B TOP FINISH': 'Top finish',
          'B2B POCKET FINISH': 'Pocket finish',
          'B2B FRONT IMAGE': 'Front design',
          'B2B BACK IMAGE': 'Back design',
          'B2B TOP IMAGE': 'Top design',
          'B2B POCKET IMAGE': 'Pocket design'
        };

        var html;
        if (visibleItems.length === 0) {
          html =
            '<div id="cd-cart-empty">' +
              '<div id="cd-cart-empty-icon">&#x1F6D2;</div>' +
              '<p>Your cart is empty</p>' +
            '</div>';
        } else {
          html = visibleItems.map(function (item) {
            var imgHtml = (item.featured_image && item.featured_image.url)
              ? '<img src="' + item.featured_image.url + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" width="80" height="80">'
              : '<span class="cd-item-thumb-placeholder">&#x1F6D2;</span>';

            var props = item.properties || {};
            var isGift = !!props[GIFT_PROP];

            // Only show properties that have a friendly label
            var propHtml = Object.keys(props).filter(function (k) {
              return PROP_LABELS[k] && props[k];
            }).map(function (k) {
              return '<div class="cd-item-prop"><span class="cd-prop-key">' + PROP_LABELS[k] + ':</span> <span>' + formatPropVal(props[k]) + '</span></div>';
            }).join('');

            // Look up this item's linked engraving SKU lines via shared _cust_id (for paired removal)
            var custId = props['_cust_id'];
            var linked = custId ? engravingMap[custId] : null;
            var engravingKey = linked ? linked.map(function (e) { return e.key; }).join(',') : '';
            var personalisationHtml = '';
            if (linked) {
              var engFinal = 0, engOrig = 0;
              linked.forEach(function (e) {
                engFinal += (e.final_line_price !== undefined ? e.final_line_price : e.line_price) || 0;
                engOrig  += (e.original_line_price !== undefined ? e.original_line_price : e.line_price) || 0;
              });
              personalisationHtml =
                '<div class="cd-item-personalisation">' +
                  '<span class="cd-personalisation-chevron"></span>' +
                  'Personalisation: ' +
                  (engOrig > engFinal ? '<s style="opacity:.55;margin-right:2px">' + money(engOrig) + '</s> ' : '') +
                  (engFinal === 0 ? 'Free' : money(engFinal)) +
                '</div>';
            }

            // Campaign discounts on this specific item (Shopify Scripts / automatic)
            var itemDiscounts = item.discounts || [];
            var hasItemDiscount = itemDiscounts.length > 0 &&
                                  item.original_line_price > item.line_price;
            var isFree = item.line_price === 0;
            var priceColHtml = hasItemDiscount
              ? '<div class="cd-item-price-wrap">' +
                  '<span class="cd-item-orig-price">' + money(item.original_line_price) + '</span>' +
                  '<span class="cd-item-price">' + (isFree ? 'Free' : money(item.line_price)) + '</span>' +
                '</div>'
              : '<div class="cd-item-price">' + money(item.line_price) + '</div>';
            var campaignChipsHtml = hasItemDiscount
              ? '<div class="cd-item-campaigns">' +
                  itemDiscounts.map(function (d) {
                    return '<span class="cd-campaign-name">&#10003; ' + d.title + '</span>';
                  }).join('') +
                '</div>'
              : '';
            // Gift lines always show a gift chip (even before the discount kicks in)
            if (isGift && !hasItemDiscount) {
              campaignChipsHtml = '<div class="cd-item-campaigns"><span class="cd-campaign-name">&#127873; Free gift &mdash; unlocked with your order</span></div>';
            }

            // MOQ floor: prefer _moq property (set by customizer tool);
            // fall back to window.b2bMoq when the item matches the current PDP variant
            // (covers native PDP ATC which doesn't attach _moq)
            var itemMoq = parseInt(props['_moq']) || 1;
            if (itemMoq <= 1 && window.b2bMoq > 1 &&
                item.variant_id === parseInt(window._vcInitialVariantId || '0')) {
              itemMoq = parseInt(window.b2bMoq);
            }
            var minusAtFloor = itemMoq > 1 && item.quantity <= itemMoq;
            var minusDisabled = minusAtFloor ? ' disabled' : '';
            var minusClass = ' class="cd-qty' + (minusAtFloor ? ' cd-qty--floor' : '') + '"';

            return '<div class="cd-cart-item">' +
              '<div class="cd-item-thumb">' + imgHtml + '</div>' +
              '<div class="cd-item-info">' +
                '<div class="cd-item-title-row">' +
                  '<div class="cd-item-title">' + (item.product_title || item.title) + '</div>' +
                  priceColHtml +
                '</div>' +
                (item.variant_title && item.variant_title !== 'Default Title'
                  ? '<div class="cd-item-variant">' + item.variant_title + '</div>'
                  : '') +
                campaignChipsHtml +
                personalisationHtml +
                (propHtml && personalisationHtml
                  ? '<div class="cd-item-props">' + propHtml + '</div>'
                  : propHtml
                  ? '<div class="cd-item-props cd-props-open">' + propHtml + '</div>'
                  : '') +
                '<div class="cd-item-actions">' +
                  (isGift
                    // Gift lines: fixed qty 1 — colour swatches instead of qty controls
                    ? '<div class="cd-gift-variants" data-key="' + item.key + '" data-handle="' + item.handle + '" data-target="' + props[GIFT_PROP] + '" data-current="' + item.variant_id + '"></div>'
                    : '<div class="cd-qty-wrap">' +
                        '<button' + minusClass + minusDisabled + ' data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&#x2212;</button>' +
                        '<span class="cd-item-qty">' + item.quantity + '</span>' +
                        '<button class="cd-qty cd-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" data-variant-id="' + item.variant_id + '" data-is-customised="' + (item.properties && item.properties['_cust_id'] ? '1' : '') + '" aria-label="Increase quantity">+</button>' +
                      '</div>') +
                '</div>' +
              '</div>' +
              '<button class="cd-remove" data-key="' + item.key + '" data-engraving-key="' + engravingKey + '"' + (isGift ? ' data-gift-target="' + props[GIFT_PROP] + '"' : '') + ' aria-label="Remove item">&#x2715;</button>' +
            '</div>';
          }).join('');
        }

        var itemsEl = document.getElementById('cd-cart-items');
        if (itemsEl) {
          itemsEl.innerHTML = html;
        }
        showItemsLoading(false);

        updateShipBar(cart);
        loadUpsell(cart);
        populateGiftSwatches();
        }); // end syncGiftTiers().then
      });
  }

  // ─── OPTIMISTIC CART — the drawer never makes the shopper wait ─────────────
  // Taps update the screen instantly from local state; the real Shopify write
  // happens in the background, debounced so +++ becomes ONE call. The response
  // cart is repainted silently as truth. Failures roll back to Shopify's state
  // with a small inline note. Checkout is held until any pending sync lands.
  var cdLastCart = null;            // cart as last painted (base for local mutations)
  var cdLastLiquidDiscounts = [];   // cached section discounts for optimistic paints
  var cdPendingUpdates = {};        // line key -> desired qty, awaiting flush
  var cdFlushTimer = null;
  var cdSyncPromise = null;         // in-flight background write (checkout guard awaits)

  function cdHasPending() {
    for (var k in cdPendingUpdates) if (cdPendingUpdates.hasOwnProperty(k)) return true;
    return false;
  }

  function optimisticChange(key, qty, engravingKey) {
    if (!cdLastCart) { cartChange(key, qty, engravingKey, null); return; } // no local state yet — old path
    cdPendingUpdates[key] = qty;
    if (qty === 0 && engravingKey) {
      engravingKey.split(',').forEach(function (k) { cdPendingUpdates[k] = 0; });
    }
    // Mutate the local cart and repaint instantly (no network on this path)
    var count = 0, total = 0;
    cdLastCart.items = cdLastCart.items.filter(function (i) {
      if (cdPendingUpdates.hasOwnProperty(i.key)) {
        var q = cdPendingUpdates[i.key];
        if (q === 0) return false;
        i.quantity = q;
        i.line_price = (i.price || 0) * q;
        i.original_line_price = (i.original_price || i.price || 0) * q;
        i.final_line_price = (i.final_price || i.price || 0) * q;
      }
      return true;
    });
    cdLastCart.items.forEach(function (i) { count += i.quantity; total += (i.final_line_price || 0); });
    cdLastCart.item_count = count;
    cdLastCart.total_price = total;
    render(cdLastCart, { optimistic: true });
    if (cdFlushTimer) clearTimeout(cdFlushTimer);
    cdFlushTimer = setTimeout(flushCartUpdates, 400);
  }

  function flushCartUpdates() {
    if (cdFlushTimer) { clearTimeout(cdFlushTimer); cdFlushTimer = null; }
    if (!cdHasPending()) return cdSyncPromise || Promise.resolve();
    var updates = cdPendingUpdates;
    cdPendingUpdates = {};
    // Serialise behind any in-flight write — parallel cart writes corrupt each other
    var base = cdSyncPromise || Promise.resolve();
    var p = base.then(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
      .then(function (r) { if (!r.ok) throw new Error('cart update failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // If more taps queued while we were in flight, their flush will repaint —
        // skip painting this already-stale cart.
        if (!cdHasPending()) return render(cart);
      })
      .catch(function () {
        // Roll back to Shopify's truth and tell the shopper, quietly
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { cdShowError("Couldn't update your cart — try again"); return render(cart); })
          .catch(function () {});
      })
      .then(function () { if (cdSyncPromise === p) cdSyncPromise = null; });
    cdSyncPromise = p;
    return p;
  }

  function settleCartSync() {
    var inflight = cdSyncPromise || Promise.resolve();
    return inflight.then(function () {
      if (cdHasPending()) return flushCartUpdates();
    });
  }

  function cdShowError(msg) {
    var itemsEl = document.getElementById('cd-cart-items');
    if (!itemsEl) return;
    var note = document.getElementById('cd-cart-error');
    if (!note) {
      note = document.createElement('div');
      note.id = 'cd-cart-error';
      note.setAttribute('style', 'margin:8px 0;padding:9px 12px;border-radius:8px;background:#FDECEA;color:#8C2B22;font-size:13px;text-align:center');
      itemsEl.parentNode.insertBefore(note, itemsEl);
    }
    note.textContent = msg;
    note.style.display = '';
    setTimeout(function () { note.style.display = 'none'; }, 4000);
  }

  // Back/forward cache: a page restored via the back button comes back with a
  // STALE drawer (old quantities, dead line keys) — taps from that state sync
  // wrong numbers to Shopify. Dump all local state and repaint from truth.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    cdPendingUpdates = {};
    if (cdFlushTimer) { clearTimeout(cdFlushTimer); cdFlushTimer = null; }
    cdSyncPromise = null;
    cdLastCart = null;
    render();
  });

  // Checkout guard: never send the shopper to checkout with an unsynced cart.
  // With nothing pending this does nothing — the link navigates as normal.
  document.addEventListener('click', function (e) {
    var chk = e.target.closest('#cd-cart-checkout');
    if (!chk) return;
    if (!cdSyncPromise && !cdFlushTimer && !cdHasPending()) return;
    e.preventDefault();
    showItemsLoading(true);
    settleCartSync()
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/checkout'; });
  }, true);

  function cartChange(key, qty, engravingKey, rowEl) {
    showItemsLoading(true);
    // Disable buttons in the affected row only to prevent double-click during update
    var disableScope = rowEl || document.getElementById('cd-cart-items');
    if (disableScope) {
      disableScope.querySelectorAll('.cd-qty, .cd-remove').forEach(function (b) {
        b.disabled = true;
        b.style.opacity = '0.5';
      });
    }
    var responsePromise;
    if (qty === 0 && engravingKey) {
      // Atomically remove both the main product and its linked engraving SKU line(s)
      var updates = {};
      updates[key] = 0;
      engravingKey.split(',').forEach(function (k) { updates[k] = 0; });
      responsePromise = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } else {
      responsePromise = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
    }
    responsePromise
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var discounts = cart.cart_level_discount_applications || [];
        if (discounts.length > 0) {
          // change/update response returns before discount amounts are recalculated — fetch fresh
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { return render(c); });
        }
        return render(cart);
      });
  }

  // The theme's stock component-ajax-cart.js crashes in cartCallback — it reads
  // #CartDrawer, which was removed along with the old drawer — so its
  // loadingState.destroy never runs and the ADD TO CART button is left disabled
  // with a spinner. Clear that state whenever a cart add completes, and again on
  // bfcache restores (browser back re-shows the page with the stuck state baked in).
  function resetAtcButtons() {
    document.querySelectorAll('button.btn-loading, input.btn-loading').forEach(function (b) {
      b.classList.remove('btn-loading');
      b.disabled = false;
    });
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) resetAtcButtons();
  });

  function onCartAdded() {
    openDrawer();
    resetAtcButtons();
    // the stock script flips the button back to loading while it rebuilds the old
    // drawer markup; sweep once more after it has crashed out
    setTimeout(resetAtcButtons, 1200);
  }

  // Intercept /cart/add at network level — open drawer on any successful cart add
  (function patchCartAdd() {
    var _xhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            setTimeout(onCartAdded, 50);
          }
        });
      }
      return _xhrOpen.apply(this, arguments);
    };
    if (window.fetch) {
      var _fetch = window.fetch;
      window.fetch = function () {
        var url = typeof arguments[0] === 'string'
          ? arguments[0]
          : ((arguments[0] && arguments[0].url) || '');
        var p = _fetch.apply(this, arguments);
        if (url.indexOf('/cart/add') !== -1) {
          p.then(function (r) {
            if (r.ok) setTimeout(onCartAdded, 50);
          }).catch(function () {});
        }
        return p;
      };
    }
  })();

  // Intercept collection grid quick-add clicks — prevent Debutify redirect to /cart
  // Variant ID lives on data-id of the inner <span>, no form involved
  (function patchGridATC() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add_to_cart.product-grid-item');
      if (!btn) return;
      var span = btn.querySelector('[data-id]');
      if (!span) return;
      var variantId = span.getAttribute('data-id');
      if (!variantId) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', 1);

      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { if (r.ok) setTimeout(openDrawer, 50); })
        .catch(function () {});
    }, true); // capture phase — fires before Debutify's bubble handlers
  })();

  // Backstop — if Debutify adds js-drawer-open-right to body, intercept it.
  // Cleanup (unlockScroll) always runs regardless of cdJustClosed.
  // openDrawer() is skipped only during the post-close grace period.
  (function watchOldDrawer() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class' &&
            document.body.classList.contains('js-drawer-open-right')) {
          unlockScroll();
          var old = document.getElementById('CartDrawer');
          if (old) { old.classList.remove('js-drawer-open'); old.removeAttribute('style'); }
          if (!cdJustClosed) {
            openDrawer();
          }
          break;
        }
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  })();

  // Layer 3: watch html element directly for any scroll lock Debutify sets
  // outside of the body class change path (e.g. direct style.overflow writes or
  // class additions on html). Runs continuously; no-ops when our drawer is open.
  (function watchHtmlScrollLock() {
    new MutationObserver(function () {
      var drawer = document.getElementById(DRAWER_ID);
      if (drawer && drawer.classList.contains('open')) return;
      // Our drawer is closed — clear any overflow lock on html.
      // Check for 'hidden' specifically — 'auto' is the value we deliberately set and must not be cleared.
      if (document.documentElement.style.overflow === 'hidden' ||
          document.documentElement.style.overflowY === 'hidden' ||
          document.documentElement.classList.contains('js-drawer-open') ||
          document.documentElement.classList.contains('js-drawer-open-right')) {
        unlockScroll();
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
  })();

  // Inject styles immediately on script load
  injectStyles();

  // Route any URL/cookie discount code on page load, then reconcile gift tiers
  // against the discounted totals immediately — the customer may head straight
  // to checkout without ever opening the drawer, and a gift the code no longer
  // covers must not travel with them.
  routeUrlDiscount().then(function (cart) {
    if (!cart) return;
    return syncGiftTiers(cart).then(function (giftCart) {
      var c = giftCart || cart;
      var count = c.items.filter(function (i) { return !isEngravingItem(i); })
        .reduce(function (n, i) { return n + i.quantity; }, 0);
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
      var drawer = document.getElementById(DRAWER_ID);
      if (drawer && drawer.classList.contains('open')) render();
    });
  });

  // Sync cart count badge on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var count = cart.items.filter(function (i) { return !isEngravingItem(i); })
          .reduce(function (n, i) { return n + i.quantity; }, 0);
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
      });
    });
  } else {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var count = cart.items.filter(function (i) { return !isEngravingItem(i); })
        .reduce(function (n, i) { return n + i.quantity; }, 0);
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
    });
  }
  document.addEventListener('theme:cart:loaded', function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var count = cart.items.filter(function (i) { return !isEngravingItem(i); })
        .reduce(function (n, i) { return n + i.quantity; }, 0);
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
    });
  });

  // Expose for customizer ATC callbacks
  window.openCartDrawer = openDrawer;

  // Discount apply / remove
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'cd-discount-btn') applyDiscount();
    if (e.target && e.target.id === 'cd-discount-remove-btn') removeDiscount();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.id === 'cd-discount-input') applyDiscount();
  });

  // Intercept cart icon clicks
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.js-drawer-open-button-right') ||
      e.target.closest('.js-cart-icon') ||
      e.target.closest('[aria-controls="CartDrawer"]')
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
    }
  }, true);

})();

